type FetchSuccess = {
  type: "success";
  response: any;
  status: number;
};

type ClientError = {
  type: "client_error";
  response: any;
  status: number;
};

type BackendError = {
  type: "backend_error";
};

type DecodingError = {
  type: "decoding_error";
  rawText: string;
  status: number;
  url: string;
  options: RequestInit | undefined;
};

type Response = FetchSuccess | ClientError | DecodingError | BackendError;

const defaultOptions = {
  headers: {
    "Content-Type": "application/json",
  },
};

async function fetchData(
  url: string,
  options?: RequestInit,
  ignoreResponseBodyOnOk: boolean = false,
): Promise<Response> {
  try {
    const response = await fetch(url, Object.assign({}, defaultOptions, options));
    const { status } = response;

    if (status === 204) {
      return { type: "success", response: {}, status };
    }
    if (status === 200 && ignoreResponseBodyOnOk) {
      return { type: "success", response: {}, status };
    }

    if (
      response.headers.get("Content-Type") === "application/json; charset=utf-8" ||
      response.headers.get("Content-Type") === "application/json"
    ) {
      const json = await response.json();
      if (response.ok) {
        return { type: "success", response: json, status };
      } else {
        if (json.type === "json_body_failure") {
          return { type: "decoding_error", status, rawText: json.type, url, options };
        }
        return { type: "client_error", response: json, status };
      }
    } else {
      const rawText = await response.text();
      return { type: "decoding_error", status, rawText, url, options };
    }
  } catch (e) {
    return { type: "backend_error" };
  }
}

export default fetchData;
